// extracted by mini-css-extract-plugin
export default {"top":"StepsHeader_top__-JNL5","head":"StepsHeader_head__KayHr","desc":"StepsHeader_desc__4NLXi","text":"StepsHeader_text__oW1n5"};